<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card light id="perf">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 style="text-align:center">
             <h2 style="font-weight:bold">CAREER BUILDERS ACADEMY - BOGOSO</h2>
              <h4>{{settings.school?settings.school.address1:''}}</h4>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card style="border-radius:15px;background:#eeeeee33" flat>
                    <v-card-text style="text-align:center">
                      <v-avatar color="#e75480" :tile="false" size="50px">
                        <img
                          v-if="img"
                          src="https://vuetifyjs.com/apple-touch-icon-180x180.png"
                          alt="student avatar"
                        />
                        <span v-else style="color:#fff">PR</span>
                      </v-avatar>
                      <h4>Name: {{student_details.s_bio?student_details.s_bio.name:''}}</h4>
                      <h4>Class: {{student_details.s_class?student_details.s_class.name:''}}</h4>
                      <h4>Guardian: {{student_details.s_guardian?student_details.s_guardian.name:''}}</h4>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card flat>
                    <v-card-title>
                      <h4>Performance Report({{settings.ayt?settings.ayt.acyear.year:''}})</h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row wrap>
                        <!-- graphs space -->
                        <v-flex xs12 >
                          <!-- acyear perf. graph -->
                          <v-card flat>
                            <!-- <v-card-title style="text-align:center">Summary</v-card-title> -->
                            <v-card-text style="page-break-after:always">
                              <h5>Summary</h5>
                              <line-chart
                                :chartdata="acyear_chart"
                                :height="chart_height"
                                :key="lc_key"
                              ></line-chart>
                            </v-card-text>

                             <v-card-text>
                               <h5>Detailed</h5>
                              <bar-chart
                                :chartdata="subjects_chart"
                                :height="chart_height"
                                :key="bc_key"
                              ></bar-chart>
                            </v-card-text>
                          </v-card>
                        </v-flex>


                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import BarChart from "../charts/barchart";
import LineChart from "../charts/linechart";
export default {
  name: "perfstats",
  props: {
    student_details: {
      type: Object
    },
    acyear: {
      type: Number
    }
  },
  components: {
    "bar-chart": BarChart,
    "line-chart": LineChart
  },
  data() {
    return {
      img: false,
      lc_key: 0,
      bc_key: 0,
      std_subjs: [], //subjects student is taking
      chart_height: 300,
      req_model: {
        std_id: "",
        acyear_id: ""
      },
      acyear_chart: {
        labels: [],
        datasets: [
          {
            label: "Marks",
            backgroundColor: "#f87979",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: []
          }
        ]
      },
      subjects_chart: {
        labels: [],
        datasets: []
      },

    };
  },
  computed: {
    ...mapGetters({
      perfrpt: "docs/PERFRPT",
      errors: "docs/DOC_ERROR",
      loading: "docs/DOC_LOADING",

      terms: "terms/TERMS",
      errors: "terms/TERM_ERROR",
      loading: "terms/TERM_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING"
    })
  },
  created() {
    this.$store.dispatch("terms/getAll");
    this.$store.dispatch("settings/getAll");
  },
  methods: {
    drawLChart(groupedTermScores = []) {
      //draw line chart : params => groupedTermScores will be all scores grouped by terms
      let res = groupedTermScores
        ? this.terms.map(t => {
            return {
              term: t.name,
              total_score: groupedTermScores[t.id]
                ? groupedTermScores[t.id].reduce((sum, score) => {
                    return sum + parseFloat(score.total_score);
                  }, 0)
                : 0
            };
          })
        : [];

      let term_names = res ? res.map(x => x.term) : []; //creating term names dynamically to use as labels for our chart

      let term_overall_ttl = res
        ? res.reduce((sum, t) => {
            //summing up all term scores to use as divisor when calculating percentage score
            return sum + parseFloat(t.total_score);
          }, 0)
        : 0;

      let term_perc_scores =
        term_overall_ttl > 0 && res
          ? res.map(x => {
              //calculating overall percentage for the term
              let res = (x.total_score / term_overall_ttl) * 100;
              return parseFloat(res).toFixed(2);
            })
          : [];

      //setting chart values
      this.acyear_chart.labels = term_names;
      this.acyear_chart.datasets[0].data = term_perc_scores;

      this.lc_key = this.lc_key + 1;
    },
    drawBChart(student_details, groupedTermScores = []) {
      //draw bar chart
      this.std_subjs = student_details
        ? student_details.s_class.subjects.map(x => {
            //creating subjects student learn with its id to help fish out related marks in the future for detailed report
            return {
              subj_id: x.id,
              subj_name: x.name
            };
          })
        : [];
      this.subjects_chart.labels = this.std_subjs.map(s => s.subj_name);

      let term_colors = ["darkblue", "darkgrey", "darkgreen"];

      let term_subjects_data = this.terms.map((x, idx) => {
        return {
          label: x.name,
          backgroundColor: term_colors[idx],
          data: groupedTermScores[x.id] && this.std_subjs
            ? this.std_subjs.map(s=>{
              let foundscore = groupedTermScores[x.id]? groupedTermScores[x.id].filter(c=>c.subject_id ==s.subj_id):[]
              return foundscore[0]?foundscore[0].total_score : 0
            }):[]
        };
      });

      //console.log("teeeeee..,,,", term_subjects_data);
      this.subjects_chart.datasets = term_subjects_data

      this.bc_key = this.bc_key + 1;
    }
  },
  watch: {
    student_details(val) {
      if (val) {
        this.bc_key = this.bc_key+1
        this.lc_key = this.lc_key+1
        // alert(val.id)
        this.req_model.std_id = val.id;
        this.$store.dispatch("docs/getPerfRpt", this.req_model);
      }
    },
    perfrpt(val) {
      if (val[0]) {
        let termly_scores = val[0].s_marks.reduce(
          (groups, s) => ({
            //grouped subject scores by term
            ...groups,
            [s.term_id]: [...(groups[s.term_id] || []), s]
          }),
          {}
        );

        this.drawLChart(termly_scores); //draw line chart

        this.drawBChart(val[0], termly_scores); //draw bar chart
      }
    },
    acyear(val){
      this.req_model.std_id = this.student_details.id;
      this.req_model.acyear_id = val
      this.$store.dispatch("docs/getPerfRpt", this.req_model);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/student/performanceStats.vue